import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import { useSendMyAssetFeedback } from 'actions/assets';
import { jsx as _jsx } from "react/jsx-runtime";
function Like(_ref) {
  var Component = _ref.as;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset;
  var _useSendMyAssetFeedba = useSendMyAssetFeedback({
      assetId: Number(asset === null || asset === void 0 ? void 0 : asset.id),
      showSuccessAlert: false
    }),
    sendMyAssetFeedback = _useSendMyAssetFeedba.sendMyAssetFeedback;
  function toggleLike() {
    sendMyAssetFeedback({
      rated_like: asset !== null && asset !== void 0 && asset.user_rated_like ? null : true
    });
  }
  return /*#__PURE__*/_jsx(Component, {
    icon: "like",
    isActive: asset === null || asset === void 0 ? void 0 : asset.user_rated_like,
    onClick: toggleLike,
    "data-qa": "like",
    children: t('actions_like')
  });
}
export default Like;